import { C6_PRODUCT_CARD_CHOICE } from '../../../modals/cross-selling-modal/cross-selling-products-layout';

const DEFAULT_THREE_COLUMNS = 'repeat(3, minmax(0, 1fr))';
const C6_TWO_COLUMNS = 'repeat(2, minmax(0, 1fr))';
const C6_SINGLE_COLUMN = 'minmax(0, 365px)';

export interface KioskSuggestionsProductsLayout {
  gridTemplateColumns: string;
  centerSingleCard: boolean;
}

export function resolveKioskSuggestionsProductsLayout(input: {
  productCount: number;
  productCardChoice: number | string | null | undefined;
}): KioskSuggestionsProductsLayout {
  const isC6Layout = Number(input.productCardChoice) === C6_PRODUCT_CARD_CHOICE;

  if (!isC6Layout) {
    return {
      gridTemplateColumns: DEFAULT_THREE_COLUMNS,
      centerSingleCard: false,
    };
  }

  if (input.productCount === 1) {
    return {
      gridTemplateColumns: C6_SINGLE_COLUMN,
      centerSingleCard: true,
    };
  }

  return {
    gridTemplateColumns: C6_TWO_COLUMNS,
    centerSingleCard: false,
  };
}
